// extracted by mini-css-extract-plugin
module.exports = {"block":"InviteLinkRow_block__1k9__","row":"InviteLinkRow_row__O1_Sa","field":"InviteLinkRow_field__GZtKe"};